// pages/error.js
'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import './error.css'
const ErrorPage = () => {
  const router = useRouter();

  // Redirect to home page after 5 seconds
  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      router.push('/products');
    }, 3000);

    return () => clearTimeout(redirectTimer);
  }, [router]);

  return (
    <div className="error-message">

      <h1>Oops! Something went wrong.</h1>
      <p>Redirecting you to the main Products page...</p>
    </div>
  );
};

export default ErrorPage;
